export const BACKDROP_BLUR_CLASS = 'backdrop-blur-[6px] bg-black/50';

export const UPSELL_TYPES = {
  video: 'video',
  storage: 'storage',
  facialRecognition: 'facial_recognition',
  digitization: 'digitization',
  club: 'club',
  photoRestoration: 'photo_restoration',
  genealogy: 'genealogy'
};

export const UPSELL_CTA_ACTIONS = {
  addToCart: 'add_to_cart',
  openBuilder: 'open_builder'
};

export const STORAGE_UPSELL_MARKETING = {
  tag: 'FOREVER PERMANENT STORAGE',
  icon: 'i-ri-home-heart-line',
  subtitle: 'Pay once. No subscriptions. Lifetime access. <br>Your memories safeguarded for your lifetime plus 100 years.'
};

export const STORAGE_UPSELL_MEMBER_MARKETING = {
  tag: STORAGE_UPSELL_MARKETING.tag,
  icon: STORAGE_UPSELL_MARKETING.icon,
  subtitle: 'Add more FOREVER Storage<sup>®</sup> so every new memory has a permanent home.'
};

export const VIDEO_UPSELL_CONTEXTS = {
  videoPlayback: 'video_playback',
  videoTools: 'video_tools',
  videoMerge: 'video_merge',
  engageRail: 'engage_upsell_rail',
  digitizationProjectTracker: 'digitization_project_tracker',
  digitizationProjectMadePermanent: 'digitization_project_made_permanent',
  fileDetailStreamingExpiration: 'file_detail_streaming_expiration'
};

export const STORAGE_UPSELL_CONTEXTS = {
  videoToolsStorageFull: 'video_tools_storage_full',
  videoMergeStorageFull: 'video_merge_storage_full',
  videoEditorStorageFull: 'video_editor_storage_full',
  deleteBinRestoreStorageFull: 'delete_bin_restore_storage_full',
  albumCopyStorageFull: 'album_copy_storage_full',
  fileCopyStorageFull: 'file_copy_storage_full',
  sessionStorageFullReminder: 'session_storage_full_reminder',
  storageMeterAddStorage: 'storage_meter_add_storage',
  profileNavigationAddStorage: 'profile_navigation_add_storage',
  uploaderStorageFull: 'uploader_storage_full',
  digitizationProjectMakePermanent: 'digitization_project_make_permanent',
  engageStorageRail: 'engage_storage_rail'
};

export const STORAGE_UPSELL_CTA_CONTEXTS = {
  digitizationProjectMakePermanent: 'digitization_project_make_permanent',
  digitizationProjectExpiredGracePeriod: 'digitization_project_expired_grace_period'
};

export const FACIAL_RECOGNITION_UPSELL_CONTEXTS = {
  peopleBanner: 'people_banner',
  peopleWelcome: 'people_welcome',
  peopleEmptyState: 'people_empty_state',
  engageRecentPeople: 'engage_recent_people',
  engageRail: 'engage_upsell_rail',
  digitizationProjectTracker: 'digitization_project_tracker'
};

export const DIGITIZATION_UPSELL_CONTEXTS = {
  digitizationProjectsNewBox: 'digitization_projects_new_box',
  albumContextMenu: 'album_context_menu',
  tagContextMenu: 'tag_context_menu',
  engageMoreValueRail: 'engage_more_value_rail'
};

export const DIGITIZATION_UPSELL_CTA_CONTEXTS = {
  digitizationProjectsEmptyState: 'digitization_projects_empty_state'
};

export const MORE_VALUE_UPSELL_CONTEXTS = {
  engageRail: 'engage_more_value_rail'
};
